import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";

type SyncMissingHashesResponse = {
  queuedCount: number;
};

export function useCodeReferencesSyncMissingHashesMutation({
  onSuccess,
  onError,
}: {
  onSuccess: (data: SyncMissingHashesResponse) => void;
  onError: (error: AxiosResponse<ErrorResponse>) => void;
}) {
  return useMutation<
    SyncMissingHashesResponse,
    AxiosResponse<ErrorResponse>,
    void
  >({
    mutationKey: ["admin", "code-references", "sync-missing-hashes"],
    mutationFn: () =>
      api
        .post<"/admin/code-references/sync-missing-hashes">(
          "/admin/code-references/sync-missing-hashes",
        )
        .then((res) => res.data),
    onSuccess,
    onError,
  });
}
